import React from 'react'

export const TabContract: React.FC = () => {
    return <>TabContract</>
}
